const view = {
    state: {
        isShow: true,
        isLoading: false
    },
    mutations: {
        viewShow(state) {
            state.isShow =  true
        },
        viewHide(state) {
            state.isShow = false
        },
        showLoading(state) {
            state.isLoading = true
        },
        hideLoading(state) {
            state.isLoading = false
        }
    }
}

export default view;